import { AfterViewInit, Component } from '@angular/core';
import { RegulationDto } from '@models/regulation/regulation.dto';
import { SubscriberDto } from '@models/users/subscriber.dto';
import { RegulationService } from '@services/regulation.service';
import { MenuItem, PrimeIcons } from 'primeng/api';

@Component({
  selector: 'ebs-regulation-manager',
  templateUrl: './regulation-manager.component.html',
  styleUrls: ['./regulation-manager.component.scss'],
})
export class RegulationManagerComponent implements AfterViewInit {
  public subscribers: SubscriberDto[] = [];

  public search: string = '';

  public useAccept: boolean = true;

  public items: MenuItem[] = [
    {
      command: () => this.createNewRegulation(),
      icon: PrimeIcons.USER_PLUS,
    },
  ];

  regulations: RegulationDto[] = [];

  creating: RegulationDto | undefined;

  public get canCreate(): boolean {
    return (
      this.creating !== undefined &&
      this.creating.acceptAnswer !== '' &&
      this.creating.rejectAnswer !== '' &&
      this.creating.description !== '' &&
      this.creating.title !== ''
    );
  }

  filteredSubscribers: SubscriberDto[] = [];

  constructor(private regulationSerivce: RegulationService) {}

  ngAfterViewInit(): void {
    this.loadRegulations();
  }

  loadRegulations() {
    this.regulationSerivce.getRegulationList().subscribe((res) => {
      this.regulations = res;
      this.regulationSerivce.getAcceptanceRegulationList().subscribe((subs) => {
        this.subscribers = subs;
      });
    });
  }

  createNewRegulation() {
    this.creating = {
      title: '',
      acceptAnswer: '',
      description: '',
      mandatoryAnswer: '',
      rejectAnswer: '',
    };
  }

  confirmCreate() {
    if (this.creating !== undefined) {
      this.creating.mandatoryAnswer = this.useAccept
        ? this.creating.acceptAnswer
        : this.creating.rejectAnswer;
      this.regulationSerivce
        .createRegulation([this.creating])
        .subscribe((result) => {
          this.creating = undefined;
          this.loadRegulations();
        });
    }
  }

  removeRegulation(delegate: RegulationDto) {
    this.regulationSerivce.removeRegulation([delegate]).subscribe((res) => {
      this.loadRegulations();
    });
  }
}
